
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCustomerDevices = (customerUserId?: string) => {
  return useQuery({
    queryKey: ['customer-devices', customerUserId],
    queryFn: async () => {
      if (!customerUserId) {
        return [];
      }

      // First get device assignments for the customer
      const { data: assignments, error: assignmentsError } = await supabase
        .from('device_assignments')
        .select('device_id')
        .eq('user_id', customerUserId);

      if (assignmentsError) {
        console.error('Error fetching customer device assignments:', assignmentsError);
        throw assignmentsError;
      }

      if (!assignments || assignments.length === 0) {
        return [];
      }

      // Get device details for assigned devices
      const deviceIds = assignments.map(a => a.device_id);
      const { data: devices, error: devicesError } = await supabase
        .from('device_details')
        .select('device_id, device_name, device_description, device_status, lat_wgs84, long_wgs84')
        .in('device_id', deviceIds)
        .order('device_name');

      if (devicesError) {
        console.error('Error fetching customer device details:', devicesError);
        throw devicesError;
      }

      return devices || [];
    },
    enabled: !!customerUserId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
